// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--t8koA","pin":"_02712f2b3b--pin--LHKdC","slidein":"_02712f2b3b--slidein--t1X3H","label":"_02712f2b3b--label--VF8al"};